// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/reviewer.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/reviewer.proto.
 */
export const file_pull_requests_v1_reviewer: GenFile = /*@__PURE__*/
  fileDesc("Ch9wdWxsX3JlcXVlc3RzL3YxL3Jldmlld2VyLnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSKQAQoIUmV2aWV3ZXISCgoCaWQYASABKAMSFQoNZGlzcGxheV9sb2dpbhgCIAEoCRIMCgRuYW1lGAMgASgJEhIKCmF2YXRhcl91cmwYBCABKAkSFQoNcmV2aWV3ZXJfdHlwZRgFIAEoCRIaChJvcmdhbml6YXRpb25fbG9naW4YBiABKAkSDAoEc2x1ZxgHIAEoCWIGcHJvdG8z");

/**
 * Shared reviewer wire shape (a user or a team) used across pull_requests
 * page_data endpoints (suggested_reviewers, review_requests, ...). Mirrors the
 * shared PullRequests::PageData::Shared::Reviewer payload so every consumer
 * sends identical reviewer/team objects to the client.
 *
 * @generated from message github.pull_requests.v1.Reviewer
 */
export type Reviewer = Message<"github.pull_requests.v1.Reviewer"> & {
  /**
   * Reviewer id. int64 (serialized as a JSON string) since ids can exceed the
   * int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * Display name; absent when the value is null or empty.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * Either "User" or "Team".
   *
   * @generated from field: string reviewer_type = 5;
   */
  reviewerType: string;

  /**
   * Organization login; absent for users or when the value is null.
   *
   * @generated from field: string organization_login = 6;
   */
  organizationLogin: string;

  /**
   * Bot/agent slug (e.g. Copilot) used for hovercards and app links; absent for
   * regular users and teams or when null.
   *
   * @generated from field: string slug = 7;
   */
  slug: string;
};

/**
 * Describes the message github.pull_requests.v1.Reviewer.
 * Use `create(ReviewerSchema)` to create a new message.
 */
export const ReviewerSchema: GenMessage<Reviewer> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_reviewer, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ReviewerSchema, "444c35208d08")
